import React, { useEffect, useReducer, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";

import { useSnackbar } from "notistack";
import axios from "axios";
import "./editresult.css";
import Logo from "../../../public_directory/public-routes-images/logos/Manga_Cons _Logo2.png";
import IsLoading from "../../../../isLoading";
// import from MUI
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import MailIcon from "@mui/icons-material/Mail";

import SearchIcon from "@mui/icons-material/Search";
import LockResetIcon from "@mui/icons-material/LockReset";

let data, course, courses;
export default function EditResult() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { adm } = useParams();
  const [loading, setLoading] = useState(false);
  const [editing, setIsediting] = useState(false);
  const redirect = useNavigate();
  const [appNo, setAppNo] = useState("");
  const encodedId = encodeURIComponent(appNo || adm);
  const [toggleCoursecode, setToggleCoursecode] = useState("");
  const [courseData, setCourseData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      examScore: course?.exams_score || "",
      caScore: course?.ca_score || "",
      lectures: course?.numberofHours?.lectures || "",
      practical: course?.numberofHours?.practical || "",
      tutorial: course?.numberofHours?.tutorial || "",
      total: course?.numberofHours?.total || "",
      totalScore: course?.total_score || "",
      grade: course?.grade || "",
    }
  );
  console.log(courseData);

  async function getStudentData() {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/management/result_upload/fetchStudentData/${encodedId}`
      )
      .then((response) => {
        data = response.data.data;
        courses = response.data.results;
        console.log(courses);
        if (response?.data.status === 201) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        } else if (response?.data.status === 404) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        }
        console.log(response);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }

  async function postAssesment() {
    const data = {
      examScore: courseData.examScore,
      caScore: courseData.caScore,
      lectures: courseData.lectures,
      practical: courseData.practical,
      tutorial: courseData.tutorial,
      total: courseData.total,
      totalScore: courseData.totalScore,
      grade: courseData.grade,
    };
    console.log(data);
    setLoading(true);
    await axios
      .put(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/management/result_upload/postResult/${encodedId}`,
        data
      )
      .then((response) => {
        data = response.data.data;
        courses = response.data.results;
        console.log(courses);
        if (response?.data.status === 201) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        } else if (response?.data.status === 404) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        }
        console.log(response);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }

  const courseList = courses?.map((e) => e.courseCode);
  console.log(courseList);

  async function findCourse() {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/management/result_upload/fetchCourseData/${encodedId}/${toggleCoursecode}`
      )
      .then((response) => {
        course = response.data.course;
        console.log(course);
        if (response?.data.status === 201) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        } else if (response?.data.status === 404) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        }
        console.log(response);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }

  const ca_score = (course?.continue_assessment || []).reduce(
    (sum, num) => sum + Number(num),
    0
  );

  return (
    <>
      {loading ? (
        <IsLoading />
      ) : (
        <div className="resultEditPrCont">
          <div className="resultEditPr fx-cl space1">
            <div className="resultEditPrHeader fx-ac fx-jc space4">
              <figure>
                <img src={Logo} alt="logo" />
              </figure>
              <div className="fx-cl fx-jc">
                <h2>Aministrative Content Management System</h2>
                <p>Centre for Academic Records and Results Management</p>
                <strong> Editing Student Result Console</strong>
              </div>
            </div>
            <header className="fx-ac fx-jb space4">
              <div className="adminSearchCont">
                <div className="adminSearch fx-jb">
                  <input
                    type="text"
                    name="application_number"
                    placeholder="im looking for..."
                    onChange={(event) => setAppNo(event.target.value)}
                    value={appNo}
                  />
                  <button onClick={() => getStudentData()}>
                    <SearchIcon fontSize="large" />
                  </button>
                </div>
              </div>

              <div className="fx-ac space2">
                <span>x</span>
              </div>
            </header>
            {data && (
              <div className="fx-cl space1">
                <div className="fx-jb space3">
                  <div className="resultEditPrcomp g g3 space2">
                    <div>
                      <strong>Student ID:</strong>{" "}
                      <span>{data?.admission_number}</span>
                    </div>
                    <div>
                      <strong>Full Name:</strong>{" "}
                      <span>
                        {data?.personalInfo?.first_Name +
                          " " +
                          data?.personalInfo?.sur_Name +
                          " " +
                          data?.personalInfo?.other_Name}
                      </span>
                    </div>
                    <div>
                      <strong>Date of Birth:</strong>{" "}
                      <span>
                        {data?.personalInfo?.Date_of_birth.slice(0, 10)}
                      </span>
                    </div>
                    <div>
                      <strong>Gender:</strong>{" "}
                      <span>{data?.personalInfo?.gender}</span>
                    </div>
                    <div>
                      <strong>Marital status:</strong>{" "}
                      <span>{data?.personalInfo?.Marital_status}</span>
                    </div>

                    <div>
                      <strong>Email:</strong>{" "}
                      <span>{data?.contactInfo?.email}</span>
                    </div>
                    <div>
                      <strong>Phone:</strong>{" "}
                      <span>+234{data?.contactInfo?.phone_number}</span>
                    </div>
                  </div>

                  <img
                    className="resultEditPrpassport"
                    src={data?.personalInfo?.passport}
                    alt="Student Passport"
                  />
                </div>
                <div
                  style={{
                    borderTop: "1px solid #ccc",
                    paddingTop: "1.5rem",
                    gridTemplateColumns: "1fr 1fr 1fr",
                  }}
                  className="resultEditPrcomp g g3 space2"
                >
                  <div>
                    <strong>Entry Session:</strong>{" "}
                    <span>{data?.academicInfo?.entry_session}</span>
                  </div>
                  <div>
                    <strong>Department</strong>{" "}
                    <span>{data?.academicInfo?.department}</span>
                  </div>
                  <div>
                    <strong>Programme of Study:</strong>{" "}
                    <span>{data?.academicInfo?.programme}</span>
                  </div>
                  <div>
                    <strong>Level:</strong>{" "}
                    <span>{data?.academicInfo?.level}</span>
                  </div>

                  <div>
                    <strong>Present Session:</strong>{" "}
                    <span>{data?.academicInfo?.pressent_session}</span>
                  </div>
                </div>
                <div
                  className="fx-cl"
                  style={{
                    padding: "1rem",
                    borderTop: "1px solid #ccc",
                    backgroundColor: "transparent",
                  }}
                >
                  <h3>Course Selection and Result Upload</h3>
                  <p>
                    Select the course you want to upload result for and click
                    fetch course
                  </p>
                </div>{" "}
                {course && (
                  <div className="editResultAside fx-cl space1">
                    <div className="invoice-second-container fx-jb space3">
                      <div className="invoice-inner-div">
                        <div className=" fx-cl space1">
                          <h3>{course?.courseTitle}</h3>
                          <div className="fx-cl">
                            <p>
                              <strong>Course Code:</strong> {course?.courseCode}
                            </p>
                            <p>
                              <strong>Course Title: </strong>
                              {course?.courseTitle}
                            </p>

                            <p>
                              <strong>Unit:</strong> {course?.creditUnit}
                            </p>

                            <p>
                              <strong>Semester:</strong> {course?.semester}
                            </p>
                            <p>
                              <strong>Level:</strong>{" "}
                              {data?.academicInfo?.state.level}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="invoice-inner-div">
                        <div className=" fx-cl space1">
                          <div className="fx-cl">
                            <span>&nbsp;</span>
                            <p>
                              <strong>Exams Score:</strong>{" "}
                              {course?.exams_score || "- - -"}
                            </p>
                            <p>
                              <strong>C.A Score:</strong>
                              {course?.ca_score || "- - -"}
                            </p>
                            <p>
                              <strong>Grade:</strong> {course?.grade}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {!editing ? (
                      <table className="fx-cl spacem">
                        <thead className="fx-cl spacem">
                          <tr
                            style={{
                              backgroundColor: "rgb(250 250 255)",
                              color: "#666",
                            }}
                          >
                            <th>Exams</th>
                            <th>CA score</th>
                            <th>Lecture</th>
                            <th>Practical</th>
                            <th>Tutorial</th>
                            <th>Total hours</th>
                            <th>Score</th>
                            <th>Grade</th>
                          </tr>
                        </thead>
                        <tbody className="fx-cl">
                          <tr key={course?.courseCode}>
                            <td>{course?.exams_score || "- - -"}</td>
                            <td>{ca_score || "- - -"}</td>
                            <td>{course?.numberofHours?.lectures}</td>
                            <td>
                              {course?.numberofHours?.practical || "- - -"}
                            </td>
                            <td>
                              {course?.numberofHours?.tutorial || "- - -"}
                            </td>
                            <td>{course?.numberofHours?.total || "- - -"}</td>
                            <td>{course?.total_score || "- - -"}</td>
                            <td>{course?.grade || "- - -"}</td>
                          </tr>
                        </tbody>
                      </table>
                    ) : (
                      <table className="fx-cl spacem">
                        <thead className="fx-cl spacem">
                          <tr
                            style={{
                              backgroundColor: "#007bff",
                              color: "#fff",
                            }}
                          >
                            <th>Exams</th>
                            <th>CA score</th>
                            <th>Lecture</th>
                            <th>Practical</th>
                            <th>Tutorial</th>
                            <th>Total hours</th>
                            <th>Score</th>
                            <th>Grade</th>
                          </tr>
                        </thead>
                        <tbody className="fx-cl">
                          <tr key={course?.courseCode}>
                            <td>
                              <input
                                type="number"
                                name=""
                                id=""
                                value={courseData?.examScore || ""}
                                onChange={(e) =>
                                  setCourseData({ examScore: e.target.value })
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                value={courseData?.caScore || ""}
                                onChange={(e) =>
                                  setCourseData({ caScore: e.target.value })
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                value={courseData?.lectures || ""}
                                onChange={(e) =>
                                  setCourseData({ lectures: e.target.value })
                                }
                              />
                            </td>
                            <td style={{ textAlign: "left" }}>
                              <input
                                type="number"
                                value={courseData?.practical || ""}
                                onChange={(e) =>
                                  setCourseData({ practical: e.target.value })
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                value={courseData?.tutorial || ""}
                                onChange={(e) =>
                                  setCourseData({ tutorial: e.target.value })
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                value={courseData?.total || ""}
                                onChange={(e) =>
                                  setCourseData({ total: e.target.value })
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                value={courseData?.totalScore || ""}
                                onChange={(e) =>
                                  setCourseData({ totalScore: e.target.value })
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={courseData.grade}
                                onChange={(e) =>
                                  setCourseData({ grade: e.target.value })
                                }
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
                <div
                  className="fx-cl"
                  style={{
                    backgroundColor: "rgb(217 216 213)",
                    padding: "1rem",
                    borderRadius: ".8rem",
                  }}
                >
                  <div className="fx-ac fx-jb space3">
                    <div className="fx-ac fx-jc space1">
                      <div
                        className="fx-ac spacem"
                        style={{
                          backgroundColor: "#fff",
                          color: "#666",
                          width: "19rem",
                          padding: "0.4rem 0.8rem",
                          borderRadius: "0.4rem",

                          // cursor: "pointer",
                        }}
                      >
                        <CastForEducationIcon />
                        <select
                          name="courses"
                          id=""
                          onChange={(e) => setToggleCoursecode(e.target.value)}
                          value={toggleCoursecode}
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            color: "#666",
                            fontWeight: "bold",
                            width: "100%",
                            cursor: "pointer",
                            fonstSize: "1.2rem",
                          }}
                        >
                          <option value="" disabled hidden>
                            Select course..
                          </option>
                          {courseList?.map((course, index) => (
                            <option key={index} value={course}>
                              {course}
                            </option>
                          ))}
                        </select>
                      </div>
                      <button
                        className="fx-ac spacem"
                        onClick={() => findCourse()}
                        style={{
                          backgroundColor: "rgb(183 100 205)",
                          color: "#fff",
                        }}
                      >
                        <MailIcon />
                        <span>Fetch course</span>
                      </button>
                    </div>
                    {course && (
                      <div className="fx-ac fx-jc space1">
                        {!editing ? (
                          <button
                            className="fx-ac spacem"
                            onClick={() => setIsediting(true)}
                            style={{
                              backgroundColor: "#007bff",
                              color: "#fff",
                              width: "12rem",
                            }}
                          >
                            <PrivacyTipOutlinedIcon />
                            <span>Edit score</span>
                          </button>
                        ) : (
                          <button
                            className="fx-ac spacem"
                            onClick={() => setIsediting(false)}
                            style={{
                              backgroundColor: "rgb(223 80 84)",
                              color: "#fff",
                              width: "12rem",
                            }}
                          >
                            <LockResetIcon />
                            <span>Cancel</span>
                          </button>
                        )}
                        {editing && (
                          <button
                            className="fx-ac spacem"
                            style={{
                              backgroundColor: "#00d285",
                              color: "#fff",
                              width: "12rem",
                            }}
                            onClick={() => postAssesment()}
                          >
                            <PrivacyTipOutlinedIcon />
                            <span>Submit</span>
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
